const DEFAULT_BASE_URL = process.env.REACT_APP_OPENAI_SERVER_EXPRESS;

export function createApi({ baseURL = DEFAULT_BASE_URL, baseHeaders = {} } = {}) {
  return async function api(path, { method = "GET", body, params, token, timeoutMs = 10000, headers } = {}) {
    const url = new URL(path, baseURL);

    if (params && typeof params === "object") {
      for (const [k, v] of Object.entries(params)) {
        if (v !== undefined && v !== null) url.searchParams.set(k, String(v));
      }
    }

    const allHeaders = { Accept: "application/json", ...baseHeaders, ...headers };
    if (token) allHeaders.Authorization = `Bearer ${token}`;

    const init = { method, headers: allHeaders };

    if (body !== undefined) {
      // deixa flexível: se já mandar FormData/Blob, não força JSON
      const isForm = typeof FormData !== "undefined" && body instanceof FormData;
      if (!isForm) {
        allHeaders["Content-Type"] = allHeaders["Content-Type"] ?? "application/json";
        init.body = typeof body === "string" ? body : JSON.stringify(body);
      } else {
        init.body = body;
      }
    }

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    init.signal = controller.signal;

    let res;
    try {
      res = await fetch(url, init);
    } catch (err) {
      clearTimeout(timer);
      return { ok: false, status: 0, error: err?.name === "AbortError" ? "timeout" : (err?.message || "network_error") };
    }
    clearTimeout(timer);

    const ctype = res.headers.get("content-type") || "";
    const isJson = ctype.includes("application/json");
    const data = isJson ? await res.json().catch(() => null) : await res.text();

    if (!res.ok) {
      return { ok: false, status: res.status, error: (data && (data.message || data.error)) || res.statusText, data };
    }
    return { ok: true, status: res.status, data };
  };
}

export const api = createApi();